<template>
    <esp-el-dialog ref="dialog" @doAction="doAction" :title="$t('member_subscription_record_operate_view')" width="85%" height="85%" top="5vh">
        <el-descriptions :column="3" size="small" border colon class="uniform-descriptions">
          <el-descriptions-item class="description-item">
            <template slot="label">{{$t('member_subscription_record_member_type')}}：</template>
            <span v-if="formData.intervalUnit == 'MONTH'">{{$t("member_subscription_record_member_type_month")}}</span>
            <span v-else-if="formData.intervalUnit == 'YEAR'">{{$t("member_subscription_record_member_type_year")}}</span>
            <span v-else-if="formData.intervalUnit == 'DAY'">{{$t("member_subscription_record_member_type_day")}}</span>
            <span v-else></span>
          </el-descriptions-item>
            <el-descriptions-item :label="$t('member_subscription_record_subscription_id')" class="description-item">{{formData.id}}</el-descriptions-item>
            <el-descriptions-item  class="description-item">
              <template slot="label">{{$t('member_subscription_record_status')}}：</template>
              <span v-if="formData.status == 'ACTIVE'">{{$t("member_subscription_record_status_active")}}</span>
              <span v-else-if="formData.status == 'INACTIVE'">{{$t("member_subscription_record_status_inactive")}}</span>
              <span v-else-if="formData.status == 'CANCELED'">{{$t("member_subscription_record_status_canceled")}}</span>
              <span v-else></span>
            </el-descriptions-item>
            <el-descriptions-item :label="this.$t('member_subscription_record_currency')" class="description-item">{{formData.currencyCode}}</el-descriptions-item>
            <el-descriptions-item :label="this.$t('member_subscription_record_amount')" class="description-item">{{fun(formData.mny)}}</el-descriptions-item>
            <el-descriptions-item :label="this.$t('member_subscription_record_start_time')" class="description-item">{{formatDate(formData.startDate)}}</el-descriptions-item>
            <el-descriptions-item :label="this.$t('member_subscription_record_end_time')" class="description-item">{{formatDate(formData.endDate)}}</el-descriptions-item>
        </el-descriptions>
    </esp-el-dialog>
</template>

<script>
import * as curApi from "@/api/tcode/subscriptions";

    export default {
        name: "TcodeSubscriptionsView",
        components: {},
        data() {
            return {
                formData: {
                    pk: ""
                }
            }
        },
        methods: {
          //初始化
          init(pk) {
              if (pk) {
                  curApi.get(pk).then(result => {
                      this.formData = result.data;
                  }).catch(error => {
                  })
              } else {
                  this.formData = {}
              }
              this.$refs.dialog.opened();
          },
            /**
             * 返回true 完成关闭，返回false，不关闭
             */
          doAction(callback) {
              callback(true);
          },
          fun(data){
            if (data == null || data == undefined || data == "" || data == 0) {
              return '0.00';
            }
            if (typeof (data) === 'number') {
              return (data).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
            }
            return data;
          },
          formatDate(dateString) {
            if (!dateString) return '';
            return dateString.split(' ')[0]; // 直接分割取日期部分
          },
        }
    }
</script>

<style scoped>
/* 使所有描述项宽度一致 */
.uniform-descriptions {
  width: 100%;
}

/* 设置固定列宽 */
.uniform-descriptions >>> .el-descriptions-item__cell {
  width: 33.33%; /* 3列布局，每列占1/3 */
  min-width: 250px; /* 设置最小宽度 */
}

/* 标签和内容单元格等宽 */
.uniform-descriptions >>> .el-descriptions-item__label,
{
  width: 40%;
  box-sizing: border-box;
}
.uniform-descriptions >>> .el-descriptions-item__content {
  width: 60%;
  box-sizing: border-box;
}

/* 确保内容不换行（可选） */
.uniform-descriptions >>> .el-descriptions-item__content {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/pages/tcode/subscriptions/view.vue